import { createFeatureGuard } from './createFeatureGuard';
import { Feature } from './Constants';

export const manholeInspectionGuard = createFeatureGuard(Feature.ManholeInspection);
